import {Helmet} from 'react-helmet-async'

export interface AppHelmetProps {
  title?: string
  titlePrefix?: string
}

export const AppHelmet = ({title, titlePrefix = 'MIITE | '}: AppHelmetProps) => {
  return (
    <Helmet>
      {title && (
        <title>
          {titlePrefix}
          {title}
        </title>
      )}
    </Helmet>
  )
}
